import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useSettings } from "../../shared/providers/SettingsProvider";
import { Camera } from "../../shared/components/icons";
import { CreateSnapshotDialog } from "./snapshots/CreateSnapshotDialog";

export function CaptureSnapshot() {
    const settings = useSettings();
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const isViewingSnapshot = useSelector((state: RootState) => !!state.storyline.snapshot);
    const hasStoryline = useSelector((state: RootState) => !!state.storyline.id);
    const loading = useSelector((state: RootState) => state.storyline.loading);

    if (!settings.features.snapshots) return null;
    // No snapshots of snapshots - the original capture already pins the state...
    if (isViewingSnapshot || !hasStoryline) return null;

    return (<>
        <Tooltip title="Create snapshot" arrow>
            <span>
                <IconButton id="btn-take-snapshot" disabled={loading} onClick={() => setDialogOpen(true)}>
                    <Camera size="small" />
                </IconButton>
            </span>
        </Tooltip>
        <CreateSnapshotDialog open={dialogOpen} setOpen={setDialogOpen} />
    </>);
}
